module.exports = __webpack_public_path__ + "img/title-gererator-ia.89057a67.png";